import imageToBase64 from 'image-to-base64/browser'

export default function convertImgUrlToBase64(url) {
  return new Promise((resolve, reject) => {
    imageToBase64(url).then(resolve).catch(reject)
  })
}
